const compliancePageData = {
    mainTitle : "Compliance with Regulations",
    headerImage : {
        name : "compliance.jpg",
        alt : "Compliance with regulations description"
    },
    paragraphOne : "SAB upholds a high standard of compliance with the Kingdom’s laws and regulations. In 2022, the Bank’s incidents of non-compliance with the laws and regulations promulgated by SAMA totalled as follows:",
    tableOne : {
        table : {
            headers : [
                <span>Incidents of non-compliance</span>, 
                <span>2020</span>, 
                <span>2021</span>, 
                <span>2022</span>, 
            ],
            data : [
                {
                    element : "Total incidents of non-compliance with laws and regulations ",
                    2020 : "22",
                    2021 : "15",
                    2022 : "26",
                },
                {
                    element : "Total number of non-monetary warning letters ",
                    2020 : "1",
                    2021 : "2",
                    2022 : "6",
                },
                {
                    element : "Percentage of incidents of non-compliance that resulted from whistleblowing actions",
                    2020 : "-",
                    2021 : "-",
                    2022 : "-",
                },
            ],
            note : "This metric for the year ended 31 December 2022 was subject to independent limited assurance by PricewaterhouseCoopers Public Accountants (‘PwC’) For further details, see our Reporting criteria and PwC's limited assurance report, which are available at website link to be added here",
        },
    },
    paragraphTwo : "For a comprehensive insights into SAB’s penalties by SAMA and other regulatory authorities, see page 124 of the Annual Report.",
    paragraphThree : "There were no incidents of non-compliance relating to SAB’s environmental impact, product and service information disclosure or transparency, or marketing communications.",
    paragraphFour : "For each incident that did occur, a detailed incident report was prepared outlining the root cause and the management action plan to ensure such incidents do not reoccur.",
    sectionOne : {
        title : "Whistleblowing",
        paragraphOne : "SAB maintains an organisational culture that encourages people to report wrongdoing or unethical practices. The Bank affords employees an opportunity to report any unethical behaviour through internal and external channels, with total anonymity should they wish to do so. The Bank has established a robust Whistleblowing Policy that is annually reviewed and approved by the Board. The policy ensures that concerns are captured, assessed, and investigated thoroughly and that our employees can raise complaints without fear of reprisals.",
        paragraphTwo : "The Bank’s secure Whistleblowing channels for internal and external reporting are as follows: ",
        orderedList : [
            <li>Email (Internal and External): SpeakUp@sab.com</li>,
            <li>Telephone: Internal (Ext.4440) External 011 2764440.</li>,
            <li>
                Main:<br />
                <ul className="normal-list">
                    <li>Internal Mail Riyadh Head office - 4th floor – Whistleblowing unit office</li>
                    <li>External Mail Head office: P.O. Box 9084, Riyadh 11413, Whistleblowing unit</li>
                </ul>
            </li>,
            <li>Website: www.sab.com</li>,
            <li>Intranet page (Internal): Speak Up (Compliance Reporting Hotline)</li>,
        ],
        paragraphThree : "Complaints made are treated with absolute confidentiality. Steps are taken to separate and protect communications, reports, and management information that may identify a particular whistleblower’s identity. Whistleblowers identities are not disclosed without exceptionally good reasons, such as when required by law or to facilitate a particular investigation."
    },
    tableTwo : {
        table : {
            headers : ["Internal compliance monitoring and reporting ", "2020", "2021", "2022"],
            data : [
                {
                    element : "Number of enquiries, complaints, or issues received by the legal and compliance office through an internal monitoring or reporting system",
                    2020 : "208",
                    2021 : "266",
                    2022 : "373",
                },
                {
                    element : "Percentage of enquiries, complaints, or issues received by the legal and compliance office through an internal monitoring or reporting system that were substantiated",
                    2020 : "100%",
                    2021 : "100%",
                    2022 : "100%",
                },
            ]
        },
        paragraph : "A summary of whistleblowing cases received each quarter is reported to the Board Audit Committee and the Board of Directors.",
    },
    sectionTwo : {
        title : "Financial crime",
        paragraphOne : "The Saudi Arabia Anti-Money Laundering (AML) Law, through its Articles and the Implementing Regulations, is applicable to all banks and requires all financial institutions to have adequate and sound policies, systems, measures, and controls in place to deter and prevent money laundering and terrorist financing acts.", 
        paragraphTwo : "All regulations, directives, and instructions received from SAMA pertinent to AML and combating terrorist financing (CTF) forms an integral part of the SAB AML-CTF Policy. We aim to comply with the highest standards of AML practices and CTF activities, and with the letter and spirit of the laws and regulations in force in Saudi Arabia. SAB may apply higher standards where it deems necessary to protect and safeguard the reputation of our Bank. SAB uses a proprietary solution for its risk-based transaction monitoring programme. All types of transactions are scoped into the system, which allows for behavioural profiles to be created. It identifies suspicious behaviour based on the dynamic transaction monitoring model deployed in the system.",
        paragraphThree : "For more information on SAB’s approach to mitigating financial crime, see the Risk Governance section of the Annual Report.",
        titleTwo : "Anti-Bribery and Corruption",
        paragraphFour : "The Bank maintains a zero-tolerance approach to bribery and corruption. Our Anti-Bribery and Corruption (AB&C) Policy sets the minimum standard which must be utilised Bank-wide, to ensure that a consistent and standardised approach is applied to manage bribery and corruption risks. The policy covers standards for assessing risks across gifts and entertainment, facilitation payments, recruitment, contracting and political contributions.",
        paragraphFive : "In addition to the policy, mandatory financial crimes e-learning is provided to all the staff members (including permanent and contractual staff) where individuals are reminded of their responsibility towards combating bribery and corruption. On an annual basis, the Board is also provided with an awareness session on the key compliance risks. The following training is scheduled for May 2023:"
    },
    tableThree : {
        table : {
            headers : ["Course Name", "Brief Summary", "Length (approx.)", "Assessment"],
            data : [
                {
                    name :  "Anti-Fraud, Bribery and Corruption",
                    summary : [
                        "Introduction to Fraud in Banking Sector",
                        "Cyber Threats/Fraud & Frauds using computer systems",
                        "Identifying Risks",
                        "Governance and Combating Fraud",
                        "Modern Anti-Fraud Internal Controls",
                        "Whistleblowing",
                    ],
                    length : "45 mins",
                    assessment : "Yes",
                }
            ]
        }
    },
    tableFour : {
        paragraph : "Below is a summary of SAB’s mandatory training for the year 2022:",
        table : {
            headers : ["Course Name", "Brief Summary", "Length (approx.)", "Assessment", "Completion Progress"],
            data : [
                {
                    name : "Health and Safety in The Workplace - 2022",
                    summary : {
                        list : [
                            "List the Positive Safety Attitudes in the Workplace",
                            "Define Occupational Health",
                            "Show the common Musculoskeletal Disorder issues",
                            "Show the importance of keeping work areas clean of germs and bacteria",
                            "Define Fire Safety",
                            "Show how to Use a Fire Extinguisher",
                            "Identify the Medical Emergency"
                        ]
                    },
                    length : "45 mins",
                    assessment : "Yes",
                    progress : "98.38%",
                },
                {
                    name : "Email Security 2022",
                    summary : {
                        list : [
                            "Understand the need for email security",
                            "Describe various email security safeguards",
                            "Explain various types of email threats",
                            "Identify suspicious/malicious emails",
                            "Identify the correct reporting channel for malicious emails"
                        ],
                    },
                    length : "45 mins",
                    assessment : "Yes",
                    progress : "98.43%",
                },
                {
                    name : "SAB Principles Mandatory Document",
                    summary : {
                        text : "SAB Principles overlay all policies and procedures, informing and connecting our purpose, values, strategy and risk management."
                    },
                    length : "30 mins",
                    assessment : "No",
                    progress : "98.15%",
                },
                {
                    name : "Harassment in the Workplace 2022",
                    summary : {
                        list : [
                            "What harassment is and learn about the rules for combating harassment in the workplace",
                            "The effects of harassment in the workplace",
                            "SAB's harassment policy",
                            "What qualifies as “harassment”",
                            "Methods and Forms of harassment",
                            "The definitions of Types of harassment"
                        ],
                    },
                    length : "45 mins",
                    assessment : "Yes",
                    progress : "98.03%",
                },
                {
                    name : "Protecting Our Information 2022",
                    summary : {
                        list : [
                            "Know how to keep information secure in all locations",
                            "Identify the phishing",
                            "Show the importance of information security",
                            "Show how to deal with phishing emails",
                            "Explain what the information classification is",
                            "Know what the risks are",
                            "Know how you can protect our information",
                            "Show how and when to report an incident where you work",
                        ],
                    },
                    length : "45 mins",
                    assessment : "Yes",
                    progress : "97.21%"
                    
                },
                {
                    name : "My Financial Crime Risk Responsibilities 2022",
                    summary : {
                        text : "Combating Commercial Concealment Anti-Money Laundering Sanctions",
                    },
                    length : "45 mins",
                    assessment : "Yes",
                    progress : "99.80%",
                },
            ]
        }
    },
    sectionThree : {
        image : {
            name : "compliance-1.jpg",
            alt : "Highlight and challenges description"
        },
        shortText : "The Bank experienced no confirmed incidents of corruption in 2022.",
        title : "Highlights and challenges in 2022",
        subtitle : "The Kingdom fast-tracked the adoption of digital solutions during the pandemic, and the banking sector experienced an uptick in organised social engineering fraud. While these attacks are targeted at customers, SAB and other industry players are working hard to combat this fraud. SAMA also introduced a robust Counter-Fraud Framework in October 2022, and banks are expected to achieve Maturity Level 3 by June 2023.",
    },
    sectionFour : {
        title : "Internal Audit and ESG",
        paragraphOne : "In line with SAB’s ESG strategy, Internal Audit coverage assesses the environmental and social impact of financing provided by the Bank. For any weaknesses identified, action plans are set and monitored for effectiveness. CIB audits Sustainability Risk Ratings (SRR) assigned to Wholesale Banking customers.",
        paragraphTwo : "During 2022, Internal Audit played a vital role in supporting SAB’s overall ESG strategy. This included reviewing the adequacy of customer SRRs and recommending the digitising of reports and other business processes to reduce carbon emissions.",
        paragraphThree : "All SAMA regulations, including those pertaining to annual audits, monitoring, managing, and reporting audit findings, are complied with by SAB. The third line of defence for the Bank is provided by SAB’s Internal Audit team (INA), which offers the Board unbiased assurance that both the First Line (Business and Operating Functions) and Second Line (Risk Management and Control Functions) are operating successfully within the Bank›s Risk Appetite.",
        paragraphFour : "The updated Risk Control Matrix (RCM) methodology has been implemented by INA in accordance with Institute of Internal Auditors Standards (1220, 2200, and 2201); replacing the previously utilized Audit Risk Assessment (ARA) and Audit Programs (APG). The goal of RCM is to make the entire audit process transparent and the RCM is crucial for risk assessment and audit planning, demonstrating the testing of important controls and compiling findings and recommendations from audit testing in one document.",
        table : {
            headers : ["Year", "2021", "2022", "2023 (planned)"],
            data : [
                {
                    year : "No of Audits",
                    2021 : "21",
                    2022 : "28",
                    2023 : "28",
                }
            ]
        }
    },
    sectionFive : {
        title : "2022 Audit Highlights",
        table : {
            headers : ["No", "2022 Audits"],
            data : [
                "Audit of Property Management (CRE & Physical Security combined)",
                "Processes and Controls Audit of SAB Credit Review  Risk Identification",
                "Audit of Marketing Department",
                "Themed Audit of Retail Lending Products",
                "Themed Audit of SAB Islamic Banking",
                "IT Governance and Development Lifecycle Audit",
                "Regulatory Audit of SARIE",
                "Audit of Large Corporate",
                "Governance (Company Secretary & Communication)",
                "Processes and Controls Audit of Human Resources",
                "Themed Audit of Cyber Risk Management",
                "ILAAP 2022 Review",
                "Regulatory Audit of Fraud Risk Management (Out-of-plan)",
                "Arabian Real Estate Company (ARECO)",
                "Processes and Controls Audit of Legal Function",
                "Processes and Controls Audit of Global Liquidity and Cash Management (GLCM)",
                "ICAAP 2022 Review",
                "Digital Banking",
                "Audit of Regulatory Compliance",
                "Regulatory Audit of SAIBOR/SAIBID Benchmark Procedures",
                "Themed Audit of Operational Risk Management Framework (ORMF)",
                "IT Infrastructure and Operations Audit",
                "Audit of Branches in SAB",
                "Themed Audit of Retail Credit Risk",
                "Regulatory audit of MADA",
                "Themed Audit of Corporate Credit Operations",
                "Audit of Global Corporates & Institutional Banking (GC & IB)",
                "Cyber Security Maturity Annual Assessment Review",
            ],
            paragraphOne : "For 2023, as part of Internal Audit’s mandatory learning, the Bank will provide staff with ESG-related training. The mandatory training will deepen awareness on ESG-related matters with the Bank. It will also improve the Bank’s ability to more rigorously monitor and assess ESG-related initiatives. ",
            paragraphTwo : "For more information about the Bank’s risk management, regulatory compliance, and internal audit, refer to the SAB Annual Report."
        }
    }
};

export default compliancePageData;